import React, { Component } from 'react';
import { Row, Col, DropdownButton, Dropdown } from 'react-bootstrap';

import Complementos from './complementos/Complementos';
import ConceptosManager from './components/ConceptosManager';
import TipoComprobante from '../support/enum/TipoComprobante';
import ComplementosResumen from './complementos/ComplementosResumen';

class ComprobanteIngresoEgreso extends Component {

  state = {
    complemento: ''
  };

  get isEgresoCompleted() {
    const { data } = this.props;
    const tipo = TipoComprobante.make(data.TipoDeComprobante);

    if (!tipo.isEgreso()) {
      return true;
    }

    return !!data.CfdiRelacionados
      && !!data.CfdiRelacionados.CfdiRelacionado
      && data.CfdiRelacionados.CfdiRelacionado.length > 0;
  }

  get isMotivoTraslado01() {
    const { data } = this.props;
    const { Complemento } = data;

    if (!!Complemento) {
      const { ComercioExterior } = Complemento;

      if (!!ComercioExterior) {
        if (ComercioExterior.MotivoTraslado === '01') {
          return !!data.CfdiRelacionados
            && !!data.CfdiRelacionados.CfdiRelacionado
            && data.CfdiRelacionados.CfdiRelacionado.length > 0;
        }
      }
    }

    return true;
  }

  handleOnChange = (value) => {
    this.props.onChange(value);
  }

  handleOnSetComplemento = (complemento) => {
    this.setState({
      complemento
    });

    this.props.onSetComplemento(complemento);
  }

  handleOnComplementosChange = (complementos) => {
    const { data, data: { Complemento = {} } } = this.props;

    this.props.onChange({
      ...data,
      Complemento: {
        ...Complemento,
        ...complementos
      }
    });

    this.setState({
      complemento: null,
      editing: undefined
    });

    this.props.onSetComplemento(null);
  }

  handleOnEdit = (complemento, values) => {
    const { data, data: { Complemento = {} } } = this.props;

    this.props.onChange({
      ...data,
      Complemento: {
        ...Complemento,
        [complemento]: undefined
      }
    });

    this.setState({
      complemento,
      editing: values
    });

    this.props.onSetComplemento(complemento);
  }

  handleOnDelete = (complemento) => {
    const { data, data: { Complemento = {} } } = this.props;

    this.props.onChange({
      ...data,
      Complemento: {
        ...Complemento,
        [complemento]: undefined
      }
    });

    this.setState({
      complemento: null
    });
  }

  render() {
    const { showConceptos, showComplementos, data } = this.props;
    const { complemento, editing } = this.state;

    return (
      <div>
        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Conceptos</strong>
          </div>

          { !!showConceptos && (
            <div className="section">
              <ConceptosManager
                autoFocus
                data={ data }
                onChange={ this.handleOnChange }
              />
            </div>
          )}
        </div>

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Complementos</strong>
          </div>

          { showComplementos && (
            <Row className="section">
              <Col>
                <div className="pt-2">
                  Un complemento es información adicional al CFDI requerida por el SAT de acuerdo al tipo de Régimen Fiscal y actividad dada de alta. Los complementos permiten incluir información adicional a un comprobante fiscal digital por internet(CFDI), de uso regulatorio para un sector o actividad específica, siendo protegida por el sello digital de la factura electrónica CFDI.
                </div>

                { !complemento && (
                  <div className="pt-2">
                    Si deseas agregar un complemento puedes seleccionarlo de la lista de complementos disponibles en la plataforma.

                    <DropdownButton
                      className="pt-2"
                      id="dropdown-complementos"
                      title="Complementos"
                    >
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'Donatarias') }>
                        Donatarias
                      </Dropdown.Item>
                      {/* <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'INE') }>
                        INE
                      </Dropdown.Item> */}
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'parcialesconstruccion') }>
                        Servicios Parciales Construcción
                      </Dropdown.Item>
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'VehiculoUsado') }>
                        Vehículos Usados
                      </Dropdown.Item>
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'ComercioExterior') }>
                        Comercio Exterior
                      </Dropdown.Item>
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'CartaPorte') }>
                        Carta Porte
                      </Dropdown.Item>
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'ImpuestosLocales') }>
                        Impuestos Locales
                      </Dropdown.Item>
                      <Dropdown.Item onClick={ this.handleOnSetComplemento.bind(this, 'Aerolineas') }>
                        Aerolineas
                      </Dropdown.Item>
                    </DropdownButton>

                  </div>
                )}
              </Col>
            </Row>
          )}
        </div>

        { !!showConceptos && !this.isEgresoCompleted && (
          <Row>
            <Col>
                <br />
                <p className="text-danger">Debes agregar al menos un CFDI Relacionado cuando el tipo de comprobante es Egreso.</p>
            </Col>
          </Row>
        )}

        { !!showComplementos && (
          <Row>
            <Col>
              <Complementos
                data={ editing }
                complemento={ complemento }
                input={ data }
                onChange={ this.handleOnComplementosChange }
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <ComplementosResumen
              data={ data.Complemento }
              onEdit={ this.handleOnEdit }
              onDelete={ this.handleOnDelete }
            />
          </Col>
        </Row>

        { !!showComplementos && !this.isMotivoTraslado01 && (
          <Row>
            <Col>
                <br />
                <p className="text-danger">Debes agregar al menos un CFDI Relacionado cuando el Motivo Traslado es “01” (Envío de mercancías facturadas con anterioridad).</p>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default ComprobanteIngresoEgreso;